module.exports = __webpack_public_path__ + "img/bio_b_1000.9bd2e2fd.png";